var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInviteMemberDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 445,
    height: 2,
    viewBox: "0 0 445 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1H445",
    stroke: "#FFF1C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteMemberDivider);
export default __webpack_public_path__ + "static/media/inviteMemberDivider.a37db218a1983f739016b1ca6ea98e7e.svg";
export { ForwardRef as ReactComponent };